(function () {
  "use strict";

  var header = document.querySelector(".header");
  var isHomepage = document.body.classList.contains("template-index");

  if (header && isHomepage) {
    var handleScroll = function () {
      var banners = document.querySelector(".top-banners");
      var bannersHeight = banners ? banners.offsetHeight : 0;

      if (window.scrollY > 0) {
        header.classList.add("header--scrolled");
        header.classList.remove("header--transparent");
        header.style.top = "0px";
      } else {
        header.classList.remove("header--scrolled");
        header.classList.add("header--transparent");
        header.style.top = bannersHeight + "px";
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
  }

  var heroVideos = document.querySelectorAll(".hero__video");
  if (heroVideos.length > 0) {
    var playVideos = function () {
      heroVideos.forEach(function (video) {
        if (video.paused) {
          var playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(function () {
            });
          }
        }
      });
    };

    playVideos();

    window.addEventListener("load", playVideos);

    var interactionEvents = ["touchstart", "click", "scroll"];
    var handleFirstInteraction = function () {
      playVideos();
      interactionEvents.forEach(function (event) {
        document.removeEventListener(event, handleFirstInteraction);
      });
    };
    interactionEvents.forEach(function (event) {
      document.addEventListener(event, handleFirstInteraction, { once: true, passive: true });
    });

    if ("IntersectionObserver" in window) {
      var videoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      heroVideos.forEach(function (video) {
        videoObserver.observe(video);
      });
    }
  }

  var heroSlider = document.querySelector(".hero--slider");
  if (heroSlider) {
    var slides = heroSlider.querySelectorAll(".hero__slide");
    var dots = heroSlider.querySelectorAll(".hero__dot");
    var prevBtn = heroSlider.querySelector(".hero__nav-btn--prev");
    var nextBtn = heroSlider.querySelector(".hero__nav-btn--next");

    if (slides.length > 1) {
      var currentIndex = 0;
      var autoplayInterval = null;
      var autoplayEnabled = heroSlider.dataset.autoplay === "true";
      var autoplaySpeed = parseInt(heroSlider.dataset.autoplaySpeed) || 5000;

      var goToSlide = function (index) {
        if (slides[currentIndex]) {
          slides[currentIndex].classList.remove("hero__slide--active");
        }
        if (dots[currentIndex]) {
          dots[currentIndex].classList.remove("hero__dot--active");
        }

        currentIndex = (index + slides.length) % slides.length;

        if (slides[currentIndex]) {
          slides[currentIndex].classList.add("hero__slide--active");
        }
        if (dots[currentIndex]) {
          dots[currentIndex].classList.add("hero__dot--active");
        }
      };

      var nextSlide = function () {
        goToSlide(currentIndex + 1);
      };
      var prevSlide = function () {
        goToSlide(currentIndex - 1);
      };

      var startAutoplay = function () {
        if (autoplayEnabled) {
          autoplayInterval = setInterval(nextSlide, autoplaySpeed);
        }
      };

      var stopAutoplay = function () {
        clearInterval(autoplayInterval);
      };

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          prevSlide();
          stopAutoplay();
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          nextSlide();
          stopAutoplay();
          startAutoplay();
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener("click", function () {
          goToSlide(index);
          stopAutoplay();
          startAutoplay();
        });
      });

      heroSlider.addEventListener("mouseenter", stopAutoplay);
      heroSlider.addEventListener("mouseleave", startAutoplay);

      startAutoplay();
    }
  }

  var menuToggle = document.querySelector(".header__menu-toggle");
  var mobileMenu = document.querySelector(".mobile-menu");
  var mobileMenuClose = document.querySelector(".mobile-menu__close");
  var flyoutOverlay = document.querySelector(".flyout-overlay");

  if (menuToggle && mobileMenu) {
    var menuPanels = document.querySelectorAll(".mobile-menu__panel");
    var menuItemsWithChildren = document.querySelectorAll(
      ".mobile-menu__item--has-children",
    );
    var menuBackButtons = document.querySelectorAll(".mobile-menu__back");

    var categoryItems = document.querySelectorAll(".mobile-menu__category-item");
    var subcategoryPanels = document.querySelectorAll(".mobile-menu__subcategory-panel");
    var featuredPanels = document.querySelectorAll(".mobile-menu__featured-panel");

    var isDesktop = function() {
      return window.innerWidth > 1024;
    };

    var menuCloseTimeout = null;
    var menuOpenTimeout = null;
    var categoryChangeTimeout = null;
    var currentCategory = null;

    var addHeaderHoverActive = function() {
      if (header && header.classList.contains('header--transparent')) {
        header.classList.add('header--hover-active');
      }
    };

    var removeHeaderHoverActive = function() {
      if (header) {
        header.classList.remove('header--hover-active');
      }
    };

    var updateHeaderHeight = function() {
      var header = document.querySelector(".header");
      if (header) {
        var headerRect = header.getBoundingClientRect();
        var headerHeight = headerRect.bottom;
        document.documentElement.style.setProperty("--header-height", headerHeight + "px");
      }
    };

    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);
    window.addEventListener("scroll", updateHeaderHeight);

    var openMenu = function() {
      if (menuCloseTimeout) {
        clearTimeout(menuCloseTimeout);
        menuCloseTimeout = null;
      }
      mobileMenu.classList.add("is-open");
      menuToggle.classList.add("is-active");

      addHeaderHoverActive();

      if (isDesktop() && flyoutOverlay) {
        flyoutOverlay.classList.add("is-active");
      }

      if (!isDesktop()) {
        document.body.style.overflow = "hidden";
      }
      menuPanels.forEach(function (panel) {
        panel.classList.remove("mobile-menu__panel--active");
      });
      var mainPanel = document.querySelector('[data-panel="main"]');
      if (mainPanel) {
        mainPanel.classList.add("mobile-menu__panel--active");
      }
      if (isDesktop() && categoryItems.length > 0) {
        activateCategory("kobieta", true);
      }
    };

    var closeMenu = function () {
      mobileMenu.classList.remove("is-open");
      menuToggle.classList.remove("is-active");
      document.body.style.overflow = "";

      removeHeaderHoverActive();

      if (flyoutOverlay) {
        flyoutOverlay.classList.remove("is-active");
      }

      currentCategory = null;
      categoryItems.forEach(function(item) {
        item.classList.remove("is-active");
      });
      subcategoryPanels.forEach(function(panel) {
        panel.classList.remove("is-active");
      });
      featuredPanels.forEach(function(panel) {
        panel.classList.remove("is-active");
      });
    };

    var closeMenuDelayed = function() {
      menuCloseTimeout = setTimeout(function() {
        closeMenu();
      }, 150);
    };

    var activateCategory = function(category, immediate) {
      if (category === currentCategory) return;

      var doActivation = function() {
        currentCategory = category;

        categoryItems.forEach(function(item) {
          if (item.dataset.category === category) {
            item.classList.add("is-active");
          } else {
            item.classList.remove("is-active");
          }
        });

        subcategoryPanels.forEach(function(panel) {
          if (panel.dataset.subcategory === category) {
            panel.classList.add("is-active");
          } else {
            panel.classList.remove("is-active");
          }
        });

        featuredPanels.forEach(function(panel) {
          if (panel.dataset.featured === category) {
            panel.classList.add("is-active");
          } else {
            panel.classList.remove("is-active");
          }
        });
      };

      if (immediate) {
        doActivation();
      } else {
        if (categoryChangeTimeout) {
          clearTimeout(categoryChangeTimeout);
        }
        categoryChangeTimeout = setTimeout(doActivation, 80);
      }
    };

    menuToggle.addEventListener("mouseenter", function() {
      if (isDesktop()) {
        addHeaderHoverActive();

        if (menuCloseTimeout) {
          clearTimeout(menuCloseTimeout);
          menuCloseTimeout = null;
        }
        menuOpenTimeout = setTimeout(function() {
          openMenu();
        }, 50);
      }
    });

    menuToggle.addEventListener("click", function(e) {
      if (!isDesktop()) {
        openMenu();
      } else {
        if (mobileMenu.classList.contains("is-open")) {
          closeMenu();
        } else {
          if (menuOpenTimeout) {
            clearTimeout(menuOpenTimeout);
          }
          openMenu();
        }
      }
    });

    mobileMenu.addEventListener("mouseenter", function() {
      if (isDesktop()) {
        if (menuCloseTimeout) {
          clearTimeout(menuCloseTimeout);
          menuCloseTimeout = null;
        }
      }
    });

    mobileMenu.addEventListener("mouseleave", function() {
      if (isDesktop()) {
        closeMenuDelayed();
      }
    });

    menuToggle.addEventListener("mouseleave", function(e) {
      if (isDesktop()) {
        if (menuOpenTimeout) {
          clearTimeout(menuOpenTimeout);
          menuOpenTimeout = null;
        }

        if (!mobileMenu.classList.contains('is-open')) {
          removeHeaderHoverActive();
        }

        closeMenuDelayed();
      }
    });

    categoryItems.forEach(function(item) {
      item.addEventListener("mouseenter", function() {
        if (isDesktop()) {
          var category = item.dataset.category;
          activateCategory(category, false);
        }
      });
    });

    if (mobileMenuClose) {
      mobileMenuClose.addEventListener("click", closeMenu);
    }

    if (flyoutOverlay) {
      flyoutOverlay.addEventListener("click", closeMenu);
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && mobileMenu.classList.contains("is-open")) {
        closeMenu();
      }
    });

    menuItemsWithChildren.forEach(function (item) {
      item.addEventListener("click", function () {
        if (!isDesktop()) {
          var targetPanel = item.dataset.target;
          var currentPanel = item.closest(".mobile-menu__panel");
          var nextPanel = document.querySelector(
            '[data-panel="' + targetPanel + '"]',
          );

          if (currentPanel && nextPanel) {
            currentPanel.classList.remove("mobile-menu__panel--active");
            nextPanel.classList.add("mobile-menu__panel--active");
          }
        }
      });
    });

    menuBackButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var targetPanel = btn.dataset.back;
        var currentPanel = btn.closest(".mobile-menu__panel");
        var prevPanel = document.querySelector(
          '[data-panel="' + targetPanel + '"]',
        );

        if (currentPanel && prevPanel) {
          currentPanel.classList.remove("mobile-menu__panel--active");
          prevPanel.classList.add("mobile-menu__panel--active");
        }
      });
    });

    mobileMenu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        closeMenu();
      });
    });

    document.addEventListener("click", function(e) {
      if (isDesktop() && mobileMenu.classList.contains("is-open")) {
        if (!mobileMenu.contains(e.target) && !menuToggle.contains(e.target)) {
          closeMenu();
        }
      }
    });
  }

  document.querySelectorAll(".product-accordion").forEach(function (acc) {
    var accHeader = acc.querySelector(".product-accordion__header");
    if (accHeader) {
      accHeader.addEventListener("click", function () {
        document.querySelectorAll(".product-accordion").forEach(function (a) {
          if (a !== acc) a.classList.remove("is-open");
        });
        acc.classList.toggle("is-open");
      });
    }
  });

  // Wybór wariantu (rozmiar/kolor) — synchronizacja z ukrytym polem id formularza
  (function () {
    var form = document.querySelector(".product-form");
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector(".product-info__add-to-cart");
    var priceEl = document.querySelector("p.product-info__price");
    var initiallyDisabled = !!(addBtn && addBtn.disabled);
    var addLabel = initiallyDisabled
      ? "Dodaj do koszyka"
      : addBtn
        ? addBtn.textContent.trim()
        : "";
    var soldOutLabel = initiallyDisabled
      ? addBtn.textContent.trim()
      : "Wyprzedane";
    // Ustawiane po załadowaniu wariantów: przycisk zablokowany przez tag "sold"
    // (produkt niedostępny w całości), a nie przez brak pierwszego wariantu.
    var forcedSoldOut = false;
    var variants = Array.isArray(window.productVariants)
      ? window.productVariants
      : null;

    function formatMoney(cents) {
      var format =
        (window.theme && window.theme.moneyFormat) || "{{amount}} zł";
      var amount = (cents / 100).toFixed(2);
      return format
        .replace("{{amount_with_comma_separator}}", amount.replace(".", ","))
        .replace("{{amount_no_decimals_with_comma_separator}}", (cents / 100).toFixed(0))
        .replace("{{amount_no_decimals}}", (cents / 100).toFixed(0))
        .replace("{{amount}}", amount);
    }

    function selectedOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll(".product-option"),
        function (opt) {
          var sel = opt.querySelector(".product-option__value.is-selected");
          return sel ? sel.getAttribute("data-value") : null;
        },
      );
    }

    function findVariant() {
      if (!variants) return null;
      var selected = selectedOptions();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = v.options || [v.option1, v.option2, v.option3];
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (selected[j] !== null && opts[j] !== selected[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function applyVariant(variant) {
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = "Niedostępne";
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            "<s>" +
            formatMoney(variant.compare_at_price) +
            '</s> <span class="sale-price">' +
            formatMoney(variant.price) +
            "</span>";
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }

      if (addBtn && !forcedSoldOut) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addLabel : soldOutLabel;
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    function markSelected(btn) {
      var option = btn.closest(".product-option");
      if (option) {
        option
          .querySelectorAll(".product-option__value")
          .forEach(function (b) {
            b.classList.remove("is-selected");
          });
      }
      btn.classList.add("is-selected");
    }

    form
      .querySelectorAll(".product-option__value:not(.is-disabled)")
      .forEach(function (btn) {
        btn.addEventListener("click", function () {
          markSelected(this);
          applyVariant(findVariant());
        });
      });

    // Zabezpieczenie: jeśli sekcja produktu nie wystawia window.productVariants,
    // pobierz warianty z endpointu /products/handle.js
    if (!variants) {
      fetch(window.location.pathname.split("?")[0] + ".js", {
        headers: { Accept: "application/json" },
      })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (product && Array.isArray(product.variants)) {
            variants = product.variants;
            init();
          }
        })
        .catch(function () {});
    } else {
      init();
    }

    function init() {
      var initial = findVariant();
      // Zablokowany przycisk mimo dostępnego wariantu = tag "sold" w Liquid
      forcedSoldOut = initiallyDisabled && !!(initial && initial.available);
      if (initial && idInput) idInput.value = initial.id;
    }
  })();

  // Uwagi do zamówienia — zapis przez AJAX (koszyk + panel koszyka)
  (function () {
    var noteTimer = null;
    var lastSavedNote = null;

    function setStatus(textarea, text, state) {
      var wrapper = textarea.parentElement;
      var status = wrapper ? wrapper.querySelector("[data-cart-note-status]") : null;
      if (!status) return;
      status.textContent = text;
      status.setAttribute("data-state", state || "");
    }

    function saveNote(textarea) {
      var note = textarea.value;
      if (note === lastSavedNote) return;
      setStatus(textarea, "Zapisywanie…", "saving");
      fetch(window.routes.cart_update_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ note: note }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("cart note save failed");
          return res.json();
        })
        .then(function () {
          lastSavedNote = note;
          setStatus(textarea, note.trim() ? "Zapisano" : "", "saved");
          document.querySelectorAll("[data-cart-note]").forEach(function (el) {
            if (el !== textarea) el.value = note;
          });
        })
        .catch(function () {
          setStatus(textarea, "Nie udało się zapisać uwag", "error");
        });
    }

    document.addEventListener("input", function (e) {
      var textarea = e.target.closest && e.target.closest("[data-cart-note]");
      if (!textarea) return;
      setStatus(textarea, "", "");
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        saveNote(textarea);
      }, 800);
    });

    document.addEventListener(
      "change",
      function (e) {
        var textarea = e.target.closest && e.target.closest("[data-cart-note]");
        if (!textarea) return;
        clearTimeout(noteTimer);
        saveNote(textarea);
      },
      true,
    );
  })();

  document
    .querySelectorAll(".cart__quantity, .quantity-selector")
    .forEach(function (sel) {
      var input = sel.querySelector(
        ".cart__quantity-input, .quantity-selector__input",
      );
      var decreaseBtn = sel.querySelector("[data-quantity-decrease]");
      var increaseBtn = sel.querySelector("[data-quantity-increase]");

      if (decreaseBtn && input) {
        decreaseBtn.addEventListener("click", function () {
          if (parseInt(input.value) > 1)
            input.value = parseInt(input.value) - 1;
        });
      }
      if (increaseBtn && input) {
        increaseBtn.addEventListener("click", function () {
          input.value = parseInt(input.value) + 1;
        });
      }
    });

  var productForm = document.querySelector(".product-form");
  if (productForm) {
    productForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = this.querySelector(".product-info__add-to-cart");
      if (!btn) return;
      var orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding...";

      fetch(window.routes.cart_add_url, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(this),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (result.ok) {
            try {
              var item = result.data || {};
              var qty = item.quantity || 1;
              var price = (item.price || item.final_price || 0) / 100;
              var currency =
                (window.Shopify &&
                  window.Shopify.currency &&
                  window.Shopify.currency.active) ||
                "PLN";
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                  currency: currency,
                  value: price * qty,
                  items: [
                    {
                      item_id: String(item.product_id || ""),
                      item_name: item.product_title || item.title || "",
                      item_variant: item.variant_title || "",
                      item_brand: item.vendor || "",
                      item_variant_id: String(item.variant_id || item.id || ""),
                      price: price,
                      quantity: qty,
                    },
                  ],
                },
              });
            } catch (err) {}

            btn.textContent = "Added!";
            setTimeout(function () {
              btn.textContent = orig;
              btn.disabled = false;
            }, 2000);
            if (window.refreshCartDrawer) window.refreshCartDrawer();
            if (window.openCartDrawer) window.openCartDrawer();
          } else {
            btn.textContent = "Error";
            setTimeout(function () {
              btn.textContent = orig;
              btn.disabled = false;
            }, 2000);
          }
        })
        .catch(function () {
          btn.textContent = "Error";
          setTimeout(function () {
            btn.textContent = orig;
            btn.disabled = false;
          }, 2000);
        });
    });
  }

  var searchToggleMobile = document.querySelector(
    ".header__search-toggle-mobile",
  );
  var searchOverlay = document.querySelector(".search-overlay");
  var searchClose = document.querySelector(".search-overlay__close");
  var searchInput = document.querySelector(".search-overlay__input");
  var searchBackdrop = document.querySelector(".search-overlay__backdrop");

  if (searchToggleMobile && searchOverlay) {
    var openSearch = function () {
      searchOverlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
      setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 100);
    };

    var closeSearch = function () {
      searchOverlay.classList.remove("is-open");
      document.body.style.overflow = "";
    };

    searchToggleMobile.addEventListener("click", openSearch);

    if (searchClose) {
      searchClose.addEventListener("click", closeSearch);
    }

    if (searchBackdrop) {
      searchBackdrop.addEventListener("click", closeSearch);
    }
  }

  var Wishlist = {
    storageKey: "berryfine_wishlist",
    drawer: null,
    drawerItems: null,
    drawerEmpty: null,
    drawerFooter: null,
    drawerCount: null,

    getItems: function () {
      try {
        var items = localStorage.getItem(this.storageKey);
        return items ? JSON.parse(items) : [];
      } catch (e) {
        return [];
      }
    },

    saveItems: function (items) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(items));
      } catch (e) {
        console.error("Could not save wishlist");
      }
    },

    addItem: function (product) {
      var items = this.getItems();
      var exists = items.some(function (item) {
        return item.id === product.id;
      });
      if (!exists) {
        items.push(product);
        this.saveItems(items);
      }
      this.updateUI();
      this.renderDrawer();
      return !exists;
    },

    removeItem: function (productId) {
      var items = this.getItems();
      items = items.filter(function (item) {
        return item.id !== productId;
      });
      this.saveItems(items);
      this.updateUI();
      this.renderDrawer();
    },

    toggleItem: function (product) {
      var items = this.getItems();
      var exists = items.some(function (item) {
        return item.id === product.id;
      });
      if (exists) {
        this.removeItem(product.id);
        return false;
      } else {
        this.addItem(product);
        return true;
      }
    },

    isInWishlist: function (productId) {
      var items = this.getItems();
      return items.some(function (item) {
        return item.id === productId;
      });
    },

    getCount: function () {
      return this.getItems().length;
    },

    openDrawer: function () {
      if (this.drawer) {
        this.renderDrawer();
        this.drawer.classList.add("is-open");
        this.drawer.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
        var mobileMenu = document.querySelector(".mobile-menu");
        if (mobileMenu && mobileMenu.classList.contains("is-open")) {
          mobileMenu.classList.remove("is-open");
        }
      }
    },

    closeDrawer: function () {
      if (this.drawer) {
        this.drawer.classList.remove("is-open");
        this.drawer.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      }
    },

    renderDrawer: function () {
      if (!this.drawerItems || !this.drawerEmpty || !this.drawerFooter) return;

      var items = this.getItems();
      var count = items.length;
      var self = this;

      if (this.drawerCount) {
        this.drawerCount.textContent = count;
      }

      if (count === 0) {
        this.drawerItems.style.display = "none";
        this.drawerEmpty.style.display = "flex";
        this.drawerFooter.style.display = "none";
        return;
      }

      this.drawerItems.style.display = "block";
      this.drawerEmpty.style.display = "none";
      this.drawerFooter.style.display = "block";

      this.drawerItems.innerHTML = items
        .map(function (item) {
          return (
            '<div class="wishlist-drawer__item" data-wishlist-item="' +
            item.id +
            '">' +
            '<div class="wishlist-drawer__image">' +
            '<a href="' +
            item.url +
            '">' +
            '<img src="' +
            item.image +
            '" alt="' +
            item.title +
            '" loading="lazy">' +
            "</a>" +
            "</div>" +
            '<div class="wishlist-drawer__info">' +
            '<a href="' +
            item.url +
            '" class="wishlist-drawer__item-title">' +
            item.title +
            "</a>" +
            '<div class="wishlist-drawer__price">' +
            item.price +
            "</div>" +
            '<button class="wishlist-drawer__remove" data-remove-wishlist="' +
            item.id +
            '">Usuń</button>' +
            "</div>" +
            "</div>"
          );
        })
        .join("");

      this.drawerItems
        .querySelectorAll("[data-remove-wishlist]")
        .forEach(function (btn) {
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            var id = btn.dataset.removeWishlist;
            self.removeItem(id);
          });
        });
    },

    updateUI: function () {
      var count = this.getCount();
      var self = this;

      var headerBadge = document.querySelector(".header__wishlist-badge");
      if (headerBadge) {
        if (count > 0) {
          headerBadge.textContent = count;
          headerBadge.style.display = "flex";
        } else {
          headerBadge.style.display = "none";
        }
      }

      var mobileCount = document.querySelector(".mobile-menu__wishlist-count");
      if (mobileCount) {
        if (count > 0) {
          mobileCount.textContent = "(" + count + ")";
        } else {
          mobileCount.textContent = "";
        }
      }

      document.querySelectorAll("[data-wishlist-add]").forEach(function (btn) {
        var productId = btn.dataset.productId;
        if (self.isInWishlist(productId)) {
          btn.classList.add("is-active");
          btn.setAttribute("aria-label", "Usuń z ulubionych");
        } else {
          btn.classList.remove("is-active");
          btn.setAttribute("aria-label", "Dodaj do ulubionych");
        }
      });
    },

    init: function () {
      var self = this;

      this.drawer = document.getElementById("wishlist-drawer");
      this.drawerItems = document.getElementById("wishlist-drawer-items");
      this.drawerEmpty = document.getElementById("wishlist-drawer-empty");
      this.drawerFooter = document.getElementById("wishlist-drawer-footer");
      this.drawerCount = document.getElementById("wishlist-drawer-count");

      this.updateUI();

      document.querySelectorAll("[data-wishlist-open]").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          self.openDrawer();
        });
      });

      document
        .querySelectorAll("[data-wishlist-close]")
        .forEach(function (btn) {
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            self.closeDrawer();
          });
        });

      document.addEventListener("keydown", function (e) {
        if (
          e.key === "Escape" &&
          self.drawer &&
          self.drawer.classList.contains("is-open")
        ) {
          self.closeDrawer();
        }
      });

      document.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-wishlist-add]");
        if (btn) {
          e.preventDefault();
          e.stopPropagation();

          var product = {
            id: btn.dataset.productId,
            handle: btn.dataset.productHandle,
            title: btn.dataset.productTitle,
            price: btn.dataset.productPrice,
            image: btn.dataset.productImage,
            url: btn.dataset.productUrl,
          };

          self.toggleItem(product);

          btn.classList.add("wishlist-btn--animating");
          setTimeout(function () {
            btn.classList.remove("wishlist-btn--animating");
          }, 300);
        }
      });

      window.addEventListener("storage", function (e) {
        if (e.key === self.storageKey) {
          self.updateUI();
          self.renderDrawer();
        }
      });
    },
  };

  Wishlist.init();

  window.Wishlist = Wishlist;
  window.openWishlistDrawer = function () {
    Wishlist.openDrawer();
  };
  window.closeWishlistDrawer = function () {
    Wishlist.closeDrawer();
  };
})();
